import { createContext } from 'react';

const CatalogManagerContext = createContext();

export default CatalogManagerContext;
